'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getComponentName = require('react-utils/getComponentName');

var _getComponentName2 = _interopRequireDefault(_getComponentName);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Component) {
  var IMESafeComponent = function (_React$Component) {
    _inherits(IMESafeComponent, _React$Component);

    function IMESafeComponent(props) {
      _classCallCheck(this, IMESafeComponent);

      var _this = _possibleConstructorReturn(this, (IMESafeComponent.__proto__ || Object.getPrototypeOf(IMESafeComponent)).call(this, props));

      _this.state = {
        composing: false
      };
      _this.handleCompositionStart = _this.handleCompositionStart.bind(_this);
      _this.handleCompositionEnd = _this.handleCompositionEnd.bind(_this);
      _this.handleKeyUp = _this.handleKeyUp.bind(_this);
      _this.handleKeyDown = _this.handleKeyDown.bind(_this);
      _this._refCallback = (0, _utils.makeDecoratorRefCallback)(Component, _this);
      return _this;
    }

    _createClass(IMESafeComponent, [{
      key: 'handleCompositionStart',
      value: function handleCompositionStart(evt) {
        var onCompositionStart = this.props.onCompositionStart;

        if (onCompositionStart) onCompositionStart(evt);
        this.setState({ composing: true });
      }
    }, {
      key: 'handleCompositionEnd',
      value: function handleCompositionEnd(evt) {
        var onCompositionEnd = this.props.onCompositionEnd;

        if (onCompositionEnd) onCompositionEnd(evt);
        this.setState({ composing: false });
      }
    }, {
      key: 'handleKeyUp',
      value: function handleKeyUp(evt) {
        var onKeyUp = this.props.onKeyUp;

        if (this.state.composing) {
          evt.stopPropagation();
        } else if (onKeyUp) {
          onKeyUp(evt);
        }
      }
    }, {
      key: 'handleKeyDown',
      value: function handleKeyDown(evt) {
        var onKeyDown = this.props.onKeyDown;

        if (this.state.composing) {
          evt.stopPropagation();
        } else if (onKeyDown) {
          onKeyDown(evt);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, {
          onCompositionStart: this.handleCompositionStart,
          onCompositionEnd: this.handleCompositionEnd,
          onKeyUp: this.handleKeyUp,
          onKeyDown: this.handleKeyDown,
          ref: this._refCallback
        }));
      }
    }]);

    return IMESafeComponent;
  }(_react2.default.Component);

  IMESafeComponent.displayName = 'IMESafe(' + (0, _getComponentName2.default)(Component) + ')';
  IMESafeComponent.propTypes = Component.propTypes;
  IMESafeComponent.defaultProps = Component.defaultProps;
  (0, _utils.attachWrappedComponent)(IMESafeComponent, Component);
  return IMESafeComponent;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/decorators/IMESafe.js
// module id = 541
// module chunks = 3 4 5